<template>
  <div class="container ">
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li aria-current="page" class="breadcrumb-item active">Projects</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-4">
              <label>Customer Name*</label>
              <multiselect
                v-model="form.cName"
                tag-placeholder="Search customer"
                placeholder="Search customer"
                label="name"
                track-by="name"
                :options="customerOptions"
                :multiple="false"
                :max-height="200"
              >
              </multiselect>
            </div>
            <div class="col-4">
              <label>Project Name *</label>
              <input class="form-control" v-model="form.pName" placeholder="Write Something ..."
                     style="border-color: #C4C4C4 !important;">
            </div>
            <div class="col-4">
              <label>Project Admin</label>
              <multiselect
                v-model="form.admins"
                tag-placeholder="Search an Admin"
                placeholder="Search an Admin"
                label="name"
                track-by="name"
                group-values="employee"
                group-label="role"
                :options="adminOptions"
                :multiple="true"
                :max-height="200"
              >
              </multiselect>
            </div>
            <div class="col-12 mt-5">
              <label>Description</label>
              <textarea class="form-control" v-model="form.description" placeholder="Write Something ..."
                        style="border-color: #C4C4C4 !important;min-height: 80px !important;"></textarea>
            </div>
            <div class="col-12 mt-10 text-right">
              <router-link to="/timesheet/projects" tag="button" class="btn btn-outline-dark col-1">Cancel</router-link>
              <button type="submit" class="btn btn-outline-primary col-1">{{ submitBtnText }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-bind:class="(showActivities)?'':'d-none'">
      <div class="row mt-30 mb-5">
        <div class="col-12 text-right">
          <button class="btn btn-light col-1" @click="copyActivities">Copy From</button>
          <button v-if="showDeleteButton" class="btn btn-danger col-1" @click="deleteActivities">Delete</button>
          <button class="btn btn-primary col-1" data-toggle="modal" data-target="#activityModal">Add</button>
        </div>
      </div>
      <div class="card">
        <div class="card-body p-0">
          <table class="table table-striped">
            <thead>
            <th width="2%">
              <input type="checkbox" v-model="selectAll">
            </th>
            <th>Activities</th>
            </thead>
            <tbody>
            <tr v-for="activity in activities">
              <td>
                <div class="form-check">
                  <input class="form-check-input" v-model="selected" type="checkbox" :value="activity.id">
                </div>
              </td>
              <td>{{ activity.name }}</td>
            </tr>
            <tr v-if="!activities.length">
              <td colspan="5" class="text-center text-page">No data found.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="activityModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Activity</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="submitActivity">
            <div class="modal-body">
              <div class="form-group">
                <label>Activity Name *</label>
                <input v-model="aName" class="form-control" type="text" placeholder="Activity name">
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">Save changes</button>
              <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="copyActivityModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Copy Activity</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="submitCopyActivity">
            <div class="modal-body">
              <div class="form-group">
                <label>Project Name *</label>
                <multiselect
                  v-model="copyProject"
                  tag-placeholder="Search customer"
                  placeholder="Search customer"
                  label="name"
                  track-by="name"
                  :options="projectsOptions"
                  :multiple="false"
                  :max-height="200"
                  @select="onSelectProject"
                >
                </multiselect>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input" v-model="selectAllCopy" type="checkbox">
                  <label class="form-check-label" >
                    Select All
                  </label>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check" v-for="activity in projectActivities">
                  <input class="form-check-input" v-model="selectedActivities" type="checkbox" :value="activity.id">
                  <label class="form-check-label" for="defaultCheck1">
                    {{activity.name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">Copy</button>
              <button type="button" class="btn btn-secondary" @click="closeCopyModal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.table tr {
  border: none !important;
}

.table td:first-child {
  width: 20px !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #F7F7F7;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

input[type=text] {
  border-color: rgb(196, 196, 196) !important;
}
</style>
<script>
import Multiselect from "vue-multiselect";
import Header from "../common/header";
import Swal from 'sweetalert2'

export default {
  name: "timesheetProjects",
  components: {
    Header,
    Multiselect,
    Swal
  },
  data() {
    return {
      form: {
        cName: "",
        pName: "",
        admins: [],
        description: "",
      },
      aName: "",
      submitBtnText: "Add",
      showActivities: false,
      project: null,
      company_id: this.$store.getters.getSelectedCompany.id,
      projects: [],
      customerOptions: [],
      adminOptions: [],
      selected: [],
      copySelected: [],
      activities: [],
      copyProject: null,
      projectActivities: [],
      projectsOptions: [],
      selectedActivities: []
    }
  },
  computed: {
    selectAll: {
      get: function () {
        return this.activities ? this.selected.length == this.activities.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.activities.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
      }
    },
    selectAllCopy: {
      get: function () {
        return this.projectActivities ? this.selectedActivities.length == this.projectActivities.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.projectActivities.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selectedActivities = selected;
      }
    },
    showDeleteButton() {
      return this.selected.length > 0;
    },
  },
  mounted() {
    this.getProject();
    this.getCustomers();
    this.getAdmins();
    this.getProjects();
  },
  methods: {

    // load all projects for this company
    getProjects() {
      let params = {
        company_id: this.company_id
      };

      this.$axios.get(this.$GetProjects, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          let copy = [];
          res.data.result.forEach(function (project){
            copy.push({
              id: project.id,
              name: project.customer.name+" - "+project.name
            })
          });
          this.projectsOptions = copy;
        }
      });
    },

    onSelectProject(selectedItems){
      this.getActivities(selectedItems.id);
    },

    // load all projects for this company
    getProject(id = null) {
      if(this.$route.params.id){
        id = this.$route.params.id;
        this.openActivities();
      }

      let params = {
        company_id: this.company_id
      };

      this.$axios.get(this.$GetProjects+"/"+id, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.project = res.data.result.project;
          this.form.pName = this.project.name;
          this.form.description = this.project.description;
          this.form.admins = this.project.admins;
          // console.log(this.form.admins, 'newData');
          this.form.cName = {
            id: this.project.customer.id,
            name: this.project.customer.name
          };
          this.getActivities();
        }
      });
    },

    openActivities(){
      this.submitBtnText = "Update";
      this.showActivities = true;
    },

    // close activity modal
    closeModal(){
      this.aName = null;
      $('#activityModal').modal('hide');
    },

    closeCopyModal(){
      this.copyProject = null;
      this.projectActivities = [];
      $('#copyActivityModal').modal('hide');
    },

    getActivities(projectId = null) {
      let params = {
        project_id: (projectId == null)?this.$route.params.id:projectId
      };

      this.$axios.get(this.$GetActivities, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          if(projectId == null) {
            this.activities = res.data.result;
          }else{
            this.projectActivities = res.data.result;
          }
        }
      });
    },

    // get customers for add/edit project
    getCustomers() {
      let params = {
        company_id: this.company_id
      };

      this.$axios.get(this.$GetCustomers, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          let customerData = [];
          res.data.result.forEach(function (customer) {
            customerData.push({
              id: customer.id,
              name: customer.name
            });
          });
          this.customerOptions = customerData;
        }
      });
    },

    // get admins for add/edit project
    getAdmins() {
      let params = {
        company_id: this.company_id,
        filter_by: 'job_role'
      };

      this.$axios.get(this.$GetAdmins, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          let adminData = [];
          res.data.result.employees.forEach(function (admin) {
            let admins = [];
            admin.list.forEach(function (user) {
              admins.push({
                name: user.name,
                id: user.id
              });
            });
            adminData.push({
              role: admin.key,
              employee: admins
            });
          });
          this.adminOptions = adminData;
        }
      });
    },

    // submit form
    submitActivity() {
      this.$axios.post(this.$AddActivity, {
        name: this.aName,
        status: 1,
        project_id: this.$route.params.id
      }, {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.aName = null;
          this.getActivities();
          $('#activityModal').modal('hide');
        }
      });
    },

    // submit copy activities form
    submitCopyActivity() {
      let url = this.$CopyActivity;
      url = url.replace(':id',this.project.id);
      this.$axios.post(url, {
        activities: this.selectedActivities
      }, {
        headers: this.getAuthHeader(),
      }).then(res => {
        if (res.data.status === 200) {
          this.closeCopyModal();
          this.getActivities();
        }
      });
    },

    // post project data
    submitForm() {
      let admins = [];
      this.form.admins.forEach(function (admin) {
        admins.push(admin.id);
      });
      let formData = {
        name: this.form.pName,
        company_id: this.company_id,
        customer_id: (this.form.cName != null) ? this.form.cName.id : null,
        admins: admins,
        description: this.form.description
      };

      let url = this.$AddProject;
      let method = "POST";
      if(this.project){
        url = this.$AddProject+'/'+this.project.id;
        method = "PATCH";
      }
      this.$axios({
        method: method,
        data: formData,
        url: url,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status === 200) {
          this.openActivities();
          this.getProject(res.data.result.project.id);
          this.getProjects();
          this.$router.push({ name: 'projectDetail', params: { id: res.data.result.project.id } });
        }
      });
    },

    copyActivities(){
      $('#copyActivityModal').modal('show');
    },

    deleteActivities(){
      new Swal({
        title: "Delete Activities?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$DeleteActivity, {
            params: {
              activities: this.selected,
              project_id: this.project.id
            },
            headers: this.getAuthHeader(),
          }).then(res => {
            if (res.data.status === 200) {
              this.getActivities();
              this.selected = [];
              this.selectAll = false;
            }
          });
        }
      });
    }
  }
}
</script>
